const Ffeatures8 = () => {
  return (
    <section id="features-8" className="wide-60 features-section division">
      <div className="container">
        {/* SECTION TITLE */}
        <div className="row justify-content-center">
          <div className="col-lg-10 col-xl-8">
            <div className="section-title title-01 mb-70">
              {/* Title */}
              <h2 className="h2-md">Powering Your Global Growth</h2>
              {/* Text */}
              <p className="p-xl">
                Our platform combines cutting-edge AI with expert-level management tools to 
                help you reach new markets faster and more accurately.
              </p>
            </div>
          </div>
        </div>
        {/* FEATURES-8 WRAPPER */}
        <div className="fbox-8-wrapper text-center">
          <div className="row row-cols-1 row-cols-md-3">
            {/* FEATURE BOX #1 */}
            <div className="col">
              <div className="fbox-8 mb-40 wow fadeInUp">
                {/* Image */}
                <div className="fbox-img bg-whitesmoke-gradient">
                  <img
                    className="img-fluid"
                    src="/images/img-21.png"
                    alt="feature-icon"
                  />
                </div>
                {/* Title */}
                <h5 className="h5-md">AI-Powered Translation</h5>
                {/* Text */}
                <p className="p-lg">
                  Instant, high-quality translations using DeepL and OpenAI to kickstart your projects.
                </p>
              </div>
            </div>
            {/* FEATURE BOX #2 */}
            <div className="col">
              <div className="fbox-8 mb-40 wow fadeInUp">
                {/* Image */}
                <div className="fbox-img bg-whitesmoke-gradient">
                  <img
                    className="img-fluid"
                    src="/images/img-22.png"
                    alt="feature-icon"
                  />
                </div>
                {/* Title */}
                <h5 className="h5-md">Translation Memory</h5>
                {/* Text */}
                <p className="p-lg">
                  Save time and money by reusing previous translations for consistent messaging.
                </p>
              </div>
            </div>
            {/* FEATURE BOX #3 */}
            <div className="col">
              <div className="fbox-8 mb-40 wow fadeInUp">
                {/* Image */}
                <div className="fbox-img bg-whitesmoke-gradient">
                  <img
                    className="img-fluid"
                    src="/images/img-24.png"
                    alt="feature-icon"
                  />
                </div>
                {/* Title */}
                <h5 className="h5-md">Smart Glossaries</h5>
                {/* Text */}
                <p className="p-lg">
                  Maintain your brand voice with predefined key terms and automated quality checks.
                </p>
              </div>
            </div>
          </div>{" "}
          {/* End row */}
        </div>{" "}
        {/* END FEATURES-8 WRAPPER */}
      </div>{" "}
      {/* End container */}
    </section>
  );
};

export default Ffeatures8;
